import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
  noindex?: boolean;
  keywords?: string;
}
export function SEO({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  twitterCard = 'summary_large_image',
  noindex = false,
  keywords
}: SEOProps) {
  const siteUrl = 'https://theHIREadvantage.co';
  const fullCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const fullOgImage = ogImage || `${siteUrl}/og-image.jpg`;
  return <Helmet data-id="element-1020">
      {/* Primary Meta Tags */}
      <title data-id="element-1021">{title}</title>
      <meta name="title" content={title} data-id="element-1022" />
      <meta name="description" content={description} data-id="element-1023" />
      {keywords && <meta name="keywords" content={keywords} data-id="element-1024" />}
      {noindex && <meta name="robots" content="noindex,nofollow" data-id="element-1025" />}

      {/* Canonical URL */}
      <link rel="canonical" href={fullCanonical} data-id="element-1026" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-1027" />
      <meta property="og:url" content={fullCanonical} data-id="element-1028" />
      <meta property="og:title" content={ogTitle || title} data-id="element-1029" />
      <meta property="og:description" content={ogDescription || description} data-id="element-1030" />
      <meta property="og:image" content={fullOgImage} data-id="element-1031" />
      <meta property="og:site_name" content="The HIRE Advantage" data-id="element-1032" />

      {/* Twitter */}
      <meta property="twitter:card" content={twitterCard} data-id="element-1033" />
      <meta property="twitter:url" content={fullCanonical} data-id="element-1034" />
      <meta property="twitter:title" content={ogTitle || title} data-id="element-1035" />
      <meta property="twitter:description" content={ogDescription || description} data-id="element-1036" />
      <meta property="twitter:image" content={fullOgImage} data-id="element-1037" />
    </Helmet>;
}